import { useCallback, useEffect } from 'react';
import { useEntityStore } from '@ContractBuilder/store';
import { useCommentsUIStore } from '@ContractBuilder/store/comments.store';
import { useDrawerStore } from '@ContractBuilder/store/drawer.store';
import { isEndorsementData } from '@ContractBuilder/types';

import { Comments } from '../views/Comments';

export const CommentsController = () => {
  const closeDrawer = useDrawerStore(({ closeDrawer }) => closeDrawer);
  const submission = useEntityStore(({ submission }) => submission);
  const reset = useCommentsUIStore(({ reset }) => reset);

  const isEndorsement = isEndorsementData(submission);

  const handleClose = useCallback(() => {
    reset();
    closeDrawer();
  }, [closeDrawer, reset]);

  useEffect(() => {
    return () => useCommentsUIStore.getState().reset();
  }, []);

  useEffect(() => {
    if (isEndorsement) {
      handleClose();
    }
  }, [isEndorsement, handleClose]);

  if (!submission || isEndorsement) {
    return null;
  }

  const data = submission.comments ?? [];

  return <Comments data={data} onClose={handleClose} />;
};
